export const T = {
  indigo: "#1E3A5F",
  indigoDark: "#142A47",
  indigoLight: "#2D5080",
  saffron: "#F4860A",
  saffronLight: "#FFF3E0",
  green: "#1A8754",
  greenLight: "#D1FAE5",
  red: "#DC2626",
  redLight: "#FEE2E2",
  gray50: "#F8FAFC",
  gray100: "#F1F5F9",
  gray200: "#E2E8F0",
  gray400: "#94A3B8",
  gray600: "#475569",
  gray800: "#1E293B",
  white: "#FFFFFF",
};